import React, {useEffect,useCallback} from 'react';
import {isMobile, isTablet} from 'react-device-detect';
import {useMedia} from 'react-use';
import {DesktopView, MobileView} from "./views";
import {useSignDocuments} from "application/use-sign-documents";
import AppRouters from "application/globals/app-routers";
import {useDispatch} from "react-redux";
import {useHistory} from "react-router-dom";

export const SignDocumentsPage = () => {
  const isWide = useMedia('(max-width: 800px)');
  const dispatch = useDispatch();
  const history = useHistory();
  const {docs = [], isAuthenticated, userInfo, onDownloadDocuments} = useSignDocuments();

  useEffect(() => {
    if(!isAuthenticated) return;

    if(!userInfo?.rut && !userInfo?.profile?.rut) {
      dispatch.common.showIncompleteProfileMessage({onClose: () => { history.replace(AppRouters.myProfile) }});
    }   
  }, [isAuthenticated, userInfo]);

  const showErrorMessage = useCallback(() => {
    dispatch.common.showErrorMessage({
      message:
        "Intente nuevamente o contáctenos.",
      title: "¡Ha Ocurrido Un Error!",     
    });
  },[]);

  if ((isMobile && !isTablet) || isWide) {
    return <MobileView docs={docs}/>;
  }

  return <DesktopView docs={docs} onDownloadDocuments={onDownloadDocuments} showErrorMessage={showErrorMessage}/>;
};
